import Panel, { type PanelProps } from '@helsenorge/core-cms/panel';

import SafeHTML from '../../components/SafeHtml';

const RightsBlock: React.FunctionComponent<PanelProps> = ({ intro, ...rest }) => (
  <Panel icon={'Scale'} {...rest}>
    {intro && <SafeHTML className="rich-text" html={intro} />}
  </Panel>
);

export default RightsBlock;
